import { Component, ViewEncapsulation } from "@angular/core";
import { DbQueryService } from "@/shared/db-query.service";
import { KpiResult, KpiWidgetBase } from "./kpi-widget-base";

@Component({
  selector: "app-orders-shipped-complete-kpi",
  templateUrl: "./orders-shipped-complete-kpi.component.html",
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class OrdersShippedCompleteKpiComponent extends KpiWidgetBase {
  constructor(private dbQueryService: DbQueryService) {
    super();
  }

  protected async fetch(fromDate: string, toDate: string): Promise<KpiResult> {
    const r = await this.dbQueryService.getOrdersShippedCompleteKpi(fromDate, toDate, this.includedAccountIds);
    return { amt: r.completeOrderCount, totalAmt: r.firstShippedOrderCount };
  }
}
